export default __webpack_public_path__ + "static/media/line1.b5819715.svg";